import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'customers-client-code',
  imports: [],
  templateUrl: './customers-client-code.component.html',
  styleUrl: './customers-client-code.component.scss'
})
export class CustomersClientCodeComponent {

  @Input() customer: any;
  @Input() readonlyClientCode!: boolean
  @Input() hasError: boolean = false;
  @Output() codeChange = new EventEmitter<string>();

  constructor() {

  }

  ngOnInit(): void {
  }

  onCodeChange(event: any): void {
    const newCode = event.value || event;
    this.codeChange.emit(newCode);
  }
}
